import { cimAxiosClient } from '@/lib';
import { ApiResponse } from '@/types';
import { withLogger } from '@/utils';

import { cimAPIUrls } from '../data';

type ADEConnectionData = {
  id: string;
  provider_id: number;
  company_id: string;
  user_id: string;
  connected: boolean;
  access_token: string;
  code: string;
  options: string;
  created_at: string;
  updated_at: string;
  token: null;
  protect_request: boolean;
  is_migrated: number;
};

type ADEConnectionResponse = {
  success: boolean;
  data: ADEConnectionData;
  message: string;
};

export type GetADECheckConnection = {
  return: ADEConnectionResponse;
};

export const getADECheckConnection = withLogger(
  async (): Promise<ADEConnectionResponse> => {
    const response = await cimAxiosClient.get<
      ApiResponse<ADEConnectionResponse>
    >(cimAPIUrls.adeCheckConnection);

    return response.data.data;
  },
);
